// LocalStorage service for PWA offline data
export class StorageService {
  static KEYS = {
    USER: 'dulce_user',
    TASKS: 'dulce_tasks',
    BUDDY: 'dulce_buddy',
    ACHIEVEMENTS: 'dulce_achievements',
    EXERCISE_HISTORY: 'dulce_exercise_history',
    FIT_LATEST: 'dulce_fit_latest',
    FIT_DAILY: 'dulce_fit_daily'
  };

  static saveUser(user) {
    localStorage.setItem(this.KEYS.USER, JSON.stringify(user));
  }

  static getUser() {
    const data = localStorage.getItem(this.KEYS.USER);
    return data ? JSON.parse(data) : null;
  }

  static saveTasks(tasks) {
    localStorage.setItem(this.KEYS.TASKS, JSON.stringify(tasks));
  }

  static getTasks() {
    const data = localStorage.getItem(this.KEYS.TASKS);
    return data ? JSON.parse(data) : [];
  }

  static saveBuddy(buddy) {
    localStorage.setItem(this.KEYS.BUDDY, JSON.stringify(buddy));
  }

  static getBuddy() {
    const data = localStorage.getItem(this.KEYS.BUDDY);
    return data ? JSON.parse(data) : null;
  }

  static saveAchievements(achievements) {
    localStorage.setItem(this.KEYS.ACHIEVEMENTS, JSON.stringify(achievements));
  }

  static getAchievements() {
    const data = localStorage.getItem(this.KEYS.ACHIEVEMENTS);
    return data ? JSON.parse(data) : [];
  }

  static saveExerciseHistory(historyMap) {
    localStorage.setItem(this.KEYS.EXERCISE_HISTORY, JSON.stringify(historyMap || {}));
  }

  static getExerciseHistory() {
    const data = localStorage.getItem(this.KEYS.EXERCISE_HISTORY);
    return data ? JSON.parse(data) : {};
  }

  static getExerciseHistoryEntry(exerciseName) {
    const history = this.getExerciseHistory();
    return history[exerciseName] || null;
  }

  static setExerciseHistoryEntry(exerciseName, entry) {
    if (!exerciseName) return;
    const history = this.getExerciseHistory();
    const updated = {
      ...history,
      [exerciseName]: {
        ...entry,
        updatedAt: entry?.updatedAt || new Date().toISOString()
      }
    };
    this.saveExerciseHistory(updated);
    return updated;
  }

  static saveGoogleFitLatest(fitLatest) {
    localStorage.setItem(this.KEYS.FIT_LATEST, JSON.stringify(fitLatest || null));
  }

  static getGoogleFitLatest() {
    const data = localStorage.getItem(this.KEYS.FIT_LATEST);
    return data ? JSON.parse(data) : null;
  }

  static saveGoogleFitDaily(history = []) {
    localStorage.setItem(this.KEYS.FIT_DAILY, JSON.stringify(Array.isArray(history) ? history : []));
  }

  static getGoogleFitDaily() {
    const data = localStorage.getItem(this.KEYS.FIT_DAILY);
    return data ? JSON.parse(data) : [];
  }

  static clearAll() {
    Object.values(this.KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  }
}

// Firebase integration placeholder (for later)
export class FirebaseService {
  // TODO: Integrate Firebase for cloud sync
  static async syncUserData(user) {
    console.log('Firebase sync not yet implemented');
    return user;
  }
}
